import React, { useEffect, useState } from 'react';
import * as PropTypes from 'prop-types';

import useStyles from './styles';

const LoadingDots = ({ size }) => {
    const classes = useStyles({ size });
    const [colors, setColors] = useState(['#6fd6c7', '#7891f3', '#f4ba64']);

    useEffect(() => {
        const interval = setInterval(() => {
            setColors([colors.pop(), ...colors]);
        }, 300);
        return () => {
            clearInterval(interval);
        };
    }, [colors]);

    return colors.map((color) => <span key={color} className={classes.animatedDot} style={{ backgroundColor: color }} />);
};

LoadingDots.defaultProps = {
    size: 4,
};

LoadingDots.propTypes = {
    size: PropTypes.number,
};

export default LoadingDots;
